import { render, staticRenderFns } from "./scrollBoard.vue?vue&type=template&id=d38c08d4&scoped=true&"
import script from "./scrollBoard.vue?vue&type=script&lang=js&"
export * from "./scrollBoard.vue?vue&type=script&lang=js&"
import style0 from "./scrollBoard.vue?vue&type=style&index=0&id=d38c08d4&prod&lang=less&scoped=true&"
import style1 from "./scrollBoard.vue?vue&type=style&index=1&id=d38c08d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38c08d4",
  null
  
)

export default component.exports